import React from 'react';
import "./Loader.css";

function Loader() {
  return (
    <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: '150px' }}>
        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
  )
}

export default Loader;
